var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.072,
    height: 72.902,
    viewBox: "0 0 80.072 72.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M555.635,389.648h.041l-13.492-23.771h-8.352l9.488,16.7h-9.489L524.1,365.729l-.255.147H492.393V382.9H483.4v-26.02h6.013l48.244.46a16.756,16.756,0,0,0,7.066-2.461l0,0a19.757,19.757,0,0,0,9.777-17.35c.051-10.363-8.154-19.593-18.594-19.817-18.7-.4-37.413-.188-56.12-.326-3.018-.022-3.906,1.3-3.843,4.1.123,5.475.178,10.961-.011,16.432-.116,3.335,1.469,4.086,4.394,4.074,17.257-.069,34.514-.027,51.77-.057,3.095-.005,6.228-.588,6.137-4.482-.085-3.646-3.084-3.961-6.019-3.959q-20.079.014-40.158-.03c-2.372,0-4.744,0-7.34,0l.014-7.554c2.272,0,3.513-.021,5.1-.018,15.481.028,30.966-.093,46.442.227,5.252.108,9.466,4.987,9.99,10.214a11.3,11.3,0,0,1-7.625,12.1,29.125,29.125,0,0,1-8.569,1.039h-.78l.04.023H476.01v40.8h23.771V373.264h20.036l9.2,16.7H556Z",
    transform: "translate(-475.925 -317.387)",
    fill: "#3cb149"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0b346b849308059f870e3077dfce02a4.svg";
export { ForwardRef as ReactComponent };